declare global {
  /* eslint-disable vars-on-top, no-var */
  interface IntercomGlobal {
    (event: string, data?: unknown): void;
    q: unknown[];
    c(...args: unknown[]): void;
  }
  var Intercom: IntercomGlobal;

  /**
   * @see https://developers.intercom.com/installing-intercom/docs/javascript-api-attributes-objects
   */
  var intercomSettings: {
    api_base: string;
    app_id: string;
    custom_launcher_selector: string;
    hide_default_launcher: boolean;
    user_id?: string;
    name?: string;
    email?: string;
  };
  /* eslint-enable vars-on-top, no-var */
}

/**
 * @see https://developers.intercom.com/installing-intercom/docs/basic-javascript
 */
export const bootstrapIntercomCode = (
  userId?: string,
  email?: string,
  name?: string
): void => {
  window.intercomSettings = {
    api_base: 'https://api-iam.intercom.io',
    app_id: INTERCOM_APP_ID,
    custom_launcher_selector: '#OpenIntercomButton',
    hide_default_launcher: true,
    user_id: userId,
    name,
    email,
  };

  const w = window;
  const ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    const d = document;
    const i: IntercomGlobal = (...args) => {
      i.c(...args);
    };

    i.q = [];
    i.c = (args) => {
      i.q.push(args);
    };

    w.Intercom = i;
    const l = () => {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
      const [x] = d.getElementsByTagName('script');
      x!.parentNode!.insertBefore(s, x!);
    };

    if (document.readyState === 'complete') {
      l();
    } else {
      w.addEventListener('load', l, false);
    }
  }
};
